var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001,
    viewBox: "0 0 16 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-icon",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_692",
    "data-name": "\\u7EC4 692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u51CF\\u53BB_1",
    "data-name": "\\u51CF\\u53BB 1",
    d: "M423-6720H413a2,2,0,0,1-2-2v-4h1v3a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-7h-3a2,2,0,0,1-2-2v-3h-5a2,2,0,0,0-2,2v1h-1v-2a2,2,0,0,1,2-2h8l4,4v10A2,2,0,0,1,423-6720Zm-3-15,0,2a2,2,0,0,0,2,2h2l-1-1-1.5-1.5Z",
    transform: "translate(-410 6736)",
    fill: "#555"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_129",
    "data-name": "\\u77E9\\u5F62 129",
    width: 7,
    height: 4,
    rx: 1,
    transform: "translate(-1 5)",
    fill: "#8d52ab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNi4wMDEiIHZpZXdCb3g9IjAgMCAxNiAxNi4wMDEiPg0KICA8ZyBpZD0iZmlsZS1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxKSI+DQogICAgPGcgaWQ9Iue7hF82OTIiIGRhdGEtbmFtZT0i57uEIDY5MiI+DQogICAgICA8cGF0aCBpZD0i5YeP5Y67XzEiIGRhdGEtbmFtZT0i5YeP5Y67IDEiIGQ9Ik00MjMtNjcyMEg0MTNhMiwyLDAsMCwxLTItMnYtNGgxdjNhMiwyLDAsMCwwLDIsMmg4YTIsMiwwLDAsMCwyLTJ2LTdoLTNhMiwyLDAsMCwxLTItMnYtM2gtNWEyLDIsMCwwLDAtMiwydjFoLTF2LTJhMiwyLDAsMCwxLDItMmg4bDQsNHYxMEEyLDIsMCwwLDEsNDIzLTY3MjBabS0zLTE1LDAsMmEyLDIsMCwwLDAsMiwyaDJsLTEtMS0xLjUtMS41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxMCA2NzM2KSIgZmlsbD0iIzU1NSIvPg0KICAgIDwvZz4NCiAgICA8cmVjdCBpZD0i55+p5b2iXzEyOSIgZGF0YS1uYW1lPSLnn6nlvaIgMTI5IiB3aWR0aD0iNyIgaGVpZ2h0PSI0IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgNSkiIGZpbGw9IiM4ZDUyYWIiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };